import PaymentMethodAccordion from './PaymentMethodAccordion'

export default PaymentMethodAccordion
